import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { FaPlus, FaRegStickyNote } from 'react-icons/fa';
import { Icon } from '@rsuite/icons';
import { useTranslation } from 'react-i18next';

function Document() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className='container-fluid'>
        <div className='shadow m-3 p-2'>
          <div
            className={`${i18n.language === 'en' ? 'row' : 'd-flex flex-row-reverse'} pb-2 my-2`}>
            <span className={`${i18n.language === 'en' ? 'ms-5' : 'me-5'} mt-5 fs-6 d-flex`}>
              <Link
                to={'../document/new'}
                className={`${
                  i18n.language === 'en' ? 'order-1' : 'order-3'
                } title text-decoration-underline`}
                style={{ textUnderlineOffset: '10px' }}>
                {i18n.language === 'en' ? (
                  <>
                    <Icon
                      as={FaPlus}
                      color='Blue'
                      className={`${i18n.language === 'en' ? 'me-1' : 'ms-1'}`}
                    />
                    <strong>{t('newDocument.document.title')}</strong>
                  </>
                ) : (
                  <>
                    <strong>{t('newDocument.document.title')}</strong>
                    <Icon
                      as={FaPlus}
                      color='Blue'
                      className={`${i18n.language === 'en' ? 'me-1' : 'ms-1'}`}
                    />
                  </>
                )}
              </Link>
              <span className={`${i18n.language === 'en' ? 'ms-3' : 'me-3 arabic'} text-muted order-2`}>
                {t('newDocument.document.continue')}
              </span>
              <Link
                to={'../document/draft'}
                className={`${
                  i18n.language === 'en' ? 'ms-3 order-3' : 'me-3 order-1'
                } title text-decoration-none`}>
                {i18n.language === 'en' ? (
                  <>
                    <Icon
                      as={FaRegStickyNote}
                      color='Blue'
                      className={`${i18n.language === 'en' ? 'me-1' : 'ms-1'}`}
                    />
                    <strong>{t('newDocument.document.draft')}</strong>
                  </>
                ) : (
                  <>
                    <strong>{t('newDocument.document.draft')}</strong>
                    <Icon
                      as={FaRegStickyNote}
                      color='Blue'
                      className={`${i18n.language === 'en' ? 'me-1' : 'ms-1'}`}
                    />
                  </>
                )}
              </Link>
            </span>
          </div>
          <Outlet />
        </div>
      </div>
    </>
  );
}

export default Document;
